import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private navCtrl: NavController,
    private tokenService: TokenService
  ) { }

  canActivate(next: ActivatedRouteSnapshot): boolean | Observable<boolean> {
    if (this.tokenService.hasValidAccessToken()) {
      return true;
    }

    if (this.tokenService.hasRefreshToken()) {
      return this.tokenService.restoreSession().pipe(
        map((restored) => {
          if (restored) {
            return true;
          }
          this.navCtrl.navigateRoot('/auth');
          return false;
        })
      );
    }

    this.tokenService.clearToken();
    this.navCtrl.navigateRoot('/auth');
    return false;
  }

  // canActivateChild(
  //   next: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  //   if(next.data?.roles > 0 && next.data?.roles.includes(this.globalAuth.role)) {
  //     return true
  //   }  
  //   return false;
  // }
}

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(
    private navCtrl: NavController,
    private tokenService: TokenService
  ) { }

  canActivate(): boolean | Observable<boolean> {
    if (this.tokenService.hasValidAccessToken()) {
      this.navCtrl.navigateRoot('/');
      return false;
    }

    if (this.tokenService.hasRefreshToken()) {
      return this.tokenService.restoreSession().pipe(
        map((restored) => {
          if (restored) {
            this.navCtrl.navigateRoot('/');
            return false;
          }
          return true;
        })
      );
    }

    return true;
  }
}
